import { render, staticRenderFns } from "./CoSyncOperateDrawer.vue?vue&type=template&id=058c7b61&scoped=true&"
import script from "./CoSyncOperateDrawer.vue?vue&type=script&lang=ts&"
export * from "./CoSyncOperateDrawer.vue?vue&type=script&lang=ts&"
import style0 from "./CoSyncOperateDrawer.vue?vue&type=style&index=0&id=058c7b61&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "058c7b61",
  null
  
)

export default component.exports